import * as React from 'react'
import * as ReactDOM from 'react-dom'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { IntlProvider } from 'react-intl'
import * as moment from 'moment'

// Config
import SubmissionForm from '@content/Submission/SubmissionForm'
import SubmissionAdditionalDetails from '@content/Submission/SubmissionAdditionalDetails'
import config from '@config/index'
import { locale, getMessages } from '@app/utils/intl'
import { SubmissionProvider } from './context/SubmissionProvider'

// Components
import Wrapper from '@app/components/Wrapper'
import { ClaimTrackerView } from './views/ClaimTracker/ClaimTrackerView'
import { getMomentLocaleForCampaign } from './utils/moment'

import './Index.scss'

// Global Scripts
import '@app/dependencies/loqate.js'

moment.locale(getMomentLocaleForCampaign(config.campaign.campaignCountry))

Bugsnag.start({
  apiKey: 'bc5a662d9c7d9d8f2aea1ba6761bd941',
  plugins: [new BugsnagPluginReact()],
  enabledReleaseStages: ['production']
})

const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React)

const claimForm = document.getElementById('claimForm')
const claimTracker = document.getElementById('claimTracker')
const claimAdditionalDetails = document.getElementById('claimAdditionalDetails')

claimForm &&
  ReactDOM.render(
    <ErrorBoundary>
      <IntlProvider defaultLocale={'en-GB'} locale={locale} messages={getMessages(locale)}>
        <Wrapper config={{ ...SubmissionForm, ...config.campaign }} />
      </IntlProvider>
    </ErrorBoundary>,
    claimForm
  )
claimTracker &&
  ReactDOM.render(
    <ErrorBoundary>
      <IntlProvider defaultLocale={'en-GB'} locale={locale} messages={getMessages(locale)}>
        <SubmissionProvider config={{ ...config.campaign, ...config.application }}>
          <ClaimTrackerView />
        </SubmissionProvider>
      </IntlProvider>
    </ErrorBoundary>,
    claimTracker
  )
claimAdditionalDetails &&
  ReactDOM.render(
    <ErrorBoundary>
      <IntlProvider defaultLocale={'en-GB'} locale={locale} messages={getMessages(locale)}>
        <Wrapper config={{ ...SubmissionAdditionalDetails, ...config.campaign }} />
      </IntlProvider>
    </ErrorBoundary>,
    claimAdditionalDetails
  )
